@use "../../styles/breakpoint.module.scss" as *;

.menuItem {
    composes: fontButton from "../../styles/composable/typography.module.css";

    a {
        color: var(--color-text-primary);
        padding: var(--spacer-16) var(--spacer-48);
        line-height: 1.5em;
        text-decoration: none;

        @media ($below-tablet) {
            display: flex;
            align-items: center;
            padding-inline: var(--spacer-24);
        }
    }
}

.menuItemSelected {
    @media ($above-tablet) {
        box-shadow: inset 0 -2px 0 0 var(--color-text-primary);
    }
}
